import React, { useState } from 'react';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { CheckCircle2, Loader2 } from 'lucide-react';

export const MarkRecordedDialog = ({ post, onOpenChange, onConfirm, saving }) => {
  const [nota, setNota] = useState('');
  return (
    <Dialog open={!!post} onOpenChange={(o) => { if (!o) { setNota(''); onOpenChange(false); } }}>
      <DialogContent className="max-w-md" data-testid="mark-recorded-dialog">
        <DialogHeader>
          <DialogTitle>Marcar como grabado</DialogTitle>
          <DialogDescription>«{post?.titulo || 'Sin título'}» pasará a estado <b>Grabado</b> y el equipo de Karma Digital recibirá el aviso.</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label htmlFor="nota-grabacion">Nota o incidencia (opcional)</Label>
          <Textarea id="nota-grabacion" rows={3} value={nota} onChange={(e) => setNota(e.target.value.slice(0, 1000))}
            placeholder='Ej: "Falta el plano final, lo grabamos el jueves" o "Cambiamos la localización por lluvia"' data-testid="mark-recorded-note-input" />
          <p className="text-[11px] text-muted-foreground">La nota la verá el equipo junto a la publicación y en el aviso.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => { setNota(''); onOpenChange(false); }} data-testid="mark-recorded-cancel-btn">Cancelar</Button>
          <Button onClick={() => onConfirm(nota.trim())} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700" data-testid="mark-recorded-confirm-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><CheckCircle2 className="w-4 h-4 mr-1" /> Confirmar grabado</>}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
